import React, { useEffect, useState } from "react";
import { CBadge, CCol, CContainer, CRow } from "@coreui/react";
import "./QuizComponent.css";

function MultipleSelect({
  type,
  num,
  question,
  score,
  data,
  onAnswerChange,
  questionID,
  questionTypeID,
  isCorrect,
  isQuestionsFetched,
  currentPage
}) {
  const [selectedOptions, setSelectedOptions] = useState([]);

  // Handle selection and deselection of options
  const handleSelectOption = (optionId) => {
    setSelectedOptions((prevSelectedOptions) => {
      if (prevSelectedOptions.includes(optionId)) {
        return prevSelectedOptions.filter((id) => id !== optionId);
      } else {
        return [...prevSelectedOptions, optionId];
      }
    });
  };

  const getIcon = (option) => {
    // If the answer is correct, display a checkmark
    if (isCorrect === 1 && option.userAnswer) {
      return <span style={{ color: '#28a745', marginLeft: '5px' }}>✔️</span>; // Green checkmark
    } 
    // If the answer is incorrect and it was selected by the user, display a red cross
    if (isCorrect === 0 && option.correctAnswer) {
      return <span style={{ color: '#dc3545', marginLeft: '5px' }}>✔️</span>; // Green checkmark
    }
    if (isCorrect === 0 && option.userAnswer) {
      return <span style={{ color: '#dc3545', marginLeft: '5px' }}>❌</span>; // Red cross
    }
    return null;
  };


  // Update the selected options in the parent component
  useEffect(() => {
    if (typeof onAnswerChange === 'function') {
      onAnswerChange(questionID, questionTypeID, selectedOptions.join(","));
    }
  }, [selectedOptions, questionID, questionTypeID]);

  // Get CSS class based on correctness and option value
  const getClassName = (option) => {
    if (isCorrect === 1 && selectedOptions.includes(option.optionId)) {
      return "reviewAnswers";
    } else if (isCorrect === 0) {
      if (selectedOptions.includes(option.optionId)) {
        return "reviewAnswers";
      }
    }
    return "";
  };

  // Determine if the inputs should be disabled
  const isDisabled = type === "review"; // Change this condition as needed

  return (
    <CContainer className="mb-3 questionContainer">
      <ol>
        <CRow className="justify-content-between">
          <CCol>
            <div>
                <span>
                  <span style={{fontWeight: '650'}}>{`Q${isQuestionsFetched ? currentPage : num + 1})`}</span>{' '}
                  <span style={{fontWeight: '650'}}>
                    {question}
                  </span>
                </span>
              <ul>
                <CRow xs={{ gutterY: 2 }}>
                  {data && data.map((option) => (
                    <CCol xs={6} lg={5} key={option.optionId}>
                      <div className="d-flex">
                        <input
                          disabled={isDisabled}
                          className={`form-check-input options ${getClassName(option)}`}
                          type="checkbox"
                          id={option.optionId}
                          name={option.optionId}
                          value={option.optionValue}
                          onChange={() => handleSelectOption(option.optionId)}
                          checked={selectedOptions.includes(option.optionId)}
                        />
                        <label
                          className="optionText"
                          style={{ marginLeft: "4px" }}
                          htmlFor={option.optionId}
                        >
                          {option.optionValue}
                        </label>
                        {getIcon(option)}
                      </div>
                    </CCol>
                  ))}
                </CRow>
              </ul>
            </div>
          </CCol>
          <CCol className="align-self-start" xs={2} md={1}>
            <div className="text-center">
              <h2>
                <CBadge title="Score per question" shape="rounded-pill" color="primary">
                  {score}
                </CBadge>
              </h2>
            </div>
          </CCol>
        </CRow>
      </ol>
    </CContainer>
  );
}

export default MultipleSelect;